import { Routes } from '@angular/router';

import { MsalGuard } from '@azure/msal-angular';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./controles/features/controles.routes').then(
        (m) => m.controlesRoutes
      ),
    canActivate: [MsalGuard],
  },
  {
    path: 'instructivo-acceso',
    loadComponent: () =>
      import(
        './shared/ui/instructivo-acceso/instructivo-acceso.component'
      ).then((m) => m.InstructivoAccesoComponent),
    canActivate: [MsalGuard],
  },
  {
    path: '**',
    redirectTo: '',
  },
];
